import React from 'react'
import { CardNew, CardSeparatorNew, Loader } from '@web/walter-ui-kit'
import cn from 'classnames'

import sharedStyles from '../style.module.css'

function Skeleton() {
    return (
        <CardNew dataPointer="asset_type_skeleton" padding="none">
            <div className={sharedStyles.content}>
                <div className={cn(sharedStyles.section, sharedStyles.top)}>
                    <div className={sharedStyles.icon}>
                        <Loader width={60} height={60} isCircled />
                    </div>
                    <div className={sharedStyles.label}>
                        <Loader width={96} height={18} />
                    </div>
                    <div className={sharedStyles.arrow}>
                        <Loader width={18} height={18} isCircled />
                    </div>
                </div>
                <CardSeparatorNew />
                <div className={cn(sharedStyles.section, sharedStyles.bottom)}>
                    <div className={sharedStyles.icon}>
                        <Loader width={60} height={60} isCircled />
                    </div>
                    <div className={sharedStyles.label}>
                        <Loader width={96} height={18} />
                    </div>
                    <div className={sharedStyles.arrow}>
                        <Loader width={18} height={18} isCircled />
                    </div>
                </div>
            </div>
        </CardNew>
    )
}

export default Skeleton
